<div class="admin-access-actions" dir="{{languageDir}}">
  <button type="button"
          class="admin-access-actions__btn admin-access-actions__btn--approve"
          (click)="onApprove($event)">
    <mat-icon>how_to_reg</mat-icon>
    <span>{{ langObj?.Approve ?? ('Approve' | translate) }}</span>
  </button>
  <button type="button"
          class="admin-access-actions__btn admin-access-actions__btn--reject"
          (click)="onReject($event)">
    <mat-icon>clear</mat-icon>
    <span>{{ langObj?.Reject ?? ('Reject' | translate) }}</span>
  </button>
</div>
